import React from 'react';
import { motion } from 'framer-motion';
import { GlassCard } from '../components/ui/GlassCard';
import { Footer } from '../components/Footer';
import { Mail, MapPin, Phone } from 'lucide-react';
import { LampContainer } from '../components/ui/LampContainer';
import { FloatingNav } from '../components/ui/FloatingNav';
export function Iletisim() {
  const contactInfo = [{
    icon: Phone,
    title: 'Telefon',
    content: '+90 505 135 16 15',
    link: 'tel:+905051351615',
    color: 'text-neon-cyan'
  }, {
    icon: Mail,
    title: 'E-posta',
    content: 'myigityilmazer@outlook.com',
    link: 'mailto:myigityilmazer@outlook.com',
    color: 'text-electric-violet'
  }, {
    icon: MapPin,
    title: 'Adres',
    content: 'Alanya TEKMER, Kestel Kampüsü, No:86/3, Antalya',
    link: null,
    color: 'text-neon-cyan'
  }];
  return <div className="min-h-screen bg-deep-dark text-white" data-id="element-220">
      {/* Floating Navigation */}
      <FloatingNav data-id="element-221" />

      {/* Lamp Hero Section - Text pushed much lower */}
      <LampContainer className="pt-24 md:pt-32 min-h-[90vh]" data-id="element-222">
        <div className="flex flex-col items-center justify-end h-full pb-6" data-id="element-223">
          <motion.h1 initial={{
          opacity: 0.5,
          y: 100
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3,
          duration: 0.8,
          ease: 'easeInOut'
        }} className="mt-64 md:mt-56 bg-gradient-to-br from-neon-cyan to-electric-violet py-4 bg-clip-text text-center text-4xl font-medium tracking-tight text-transparent md:text-7xl px-4" data-id="element-224">
            Birlikte Çalışalım
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5,
          duration: 0.8,
          ease: 'easeInOut'
        }} className="mt-4 text-lg md:text-xl text-gray-400 text-center max-w-2xl mx-auto px-4" data-id="element-225">
            Projeleriniz için bizimle iletişime geçin. Size en kısa sürede dönüş
            yapalım.
          </motion.p>
        </div>
      </LampContainer>

      {/* Contact Cards - Positioned just below text */}
      <section className="py-12 px-4 -mt-32 relative z-10" data-id="element-226">
        <div className="max-w-7xl mx-auto" data-id="element-227">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-228">
            {contactInfo.map((info, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} data-id="element-229">
                <GlassCard className="h-full p-8 hover:shadow-[0_10px_60px_-10px_rgba(0,217,255,0.2)] transition-all duration-300 backdrop-blur-xl bg-deep-dark/40 border-white/10" data-id="element-230">
                  <div className="flex flex-col items-center text-center space-y-4" data-id="element-231">
                    <div className={`p-5 bg-white/5 rounded-2xl ${info.color}`} data-id="element-232">
                      <info.icon className="w-10 h-10" data-id="element-233" />
                    </div>
                    <div className="space-y-2" data-id="element-234">
                      <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider" data-id="element-235">
                        {info.title}
                      </h3>
                      {info.link ? <a href={info.link} className="block text-lg font-bold text-white hover:text-neon-cyan transition-colors leading-relaxed" data-id="element-236">
                          {info.content}
                        </a> : <p className="text-lg font-bold text-white leading-relaxed" data-id="element-237">
                          {info.content}
                        </p>}
                    </div>
                  </div>
                </GlassCard>
              </motion.div>)}
          </div>
        </div>
      </section>

      <Footer data-id="element-238" />
    </div>;
}